<template>
  <div id="app" data>
    <div class="site-holder">
      <router-view/>
    </div>
    <quote-opener  />
    <cookie-warning  />
    <quote-panel />
    <login-shower />
    <message-panel ></message-panel>
    <template v-if="ispre">
      <div id="xjPreRender"></div>
    </template>
    <template v-else>
      <div id="xjNormal">
      </div>
    </template>
    
  </div>
</template>
<script>

import QuotePanel from '@/components/panels/QuotePanel.vue'
import CookieWarning from '@/components/panels/CookieBar.vue'
import LoginShower from '@/components/dialogs/LoginShower.vue'
import MessagePanel from '@/components/panels/MessagePanel.vue'
import QuoteOpener from '@/components/widgets/QuoteOpener.vue'



export default {
  components: {
    QuotePanel,
    LoginShower,
    CookieWarning,
    MessagePanel,
    QuoteOpener
  },
  data() {
    return {
      showOk: false,
      deferredPrompt: null,
      ispre: false
    }
  },
  created: function () {
    this.checkIn()
    if(this.$k.isPre()) {
      this.ispre = true
    }
    else {
      this.ispre = false
      
      require('./utils/bing.js')
      
    }
  },
  mounted() {
    //this.unregister()
    window._enav = this.externalNav
    console.log('version', process.env.VUE_APP_VERSION)
    console.log('nav.lang', navigator.language)
    console.log('nav.langs', navigator.languages)
  },
  methods: {
    unregister() {
      navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for(let registration of registrations) {
          registration.unregister()
          console.log('unregistered sw')
        } 
      })
    },
    async showInstallPromo() {
      this.showOk = true
      this.$k.messageBox("IllustrationX Mobile", "Would you like to install IllustrationX on your home screen?")
      
    },
    async handleInstall() {
      if(this.$store.state.deferredPrompt) {
        this.$store.state.deferredPrompt.prompt()
        let choiceResult = await this.$store.state.deferredPrompt.userChoice
        if(choiceResult.outcome === 'accepted'){
          console.log('accepted')
        }
        else {
          console.log('dismissed')
        }
      }
    },
    externalNav(url) {
      this.$router.push(url)
    },
    checkIn: async function () {
      this.$store.commit('setLang', this.$store.state.lang)
      await this.$store.dispatch('checkUser')
    }
  },
  watch: {
    '$store.state.install': function () {
      if(this.$store.state.install){
        this.showInstallPromo()
        this.$store.commit('setInstall', false)
      }
      
    }
  }
}
</script>
<style>
body {
  font-family: gibbs, sans-serif;
  font-weight: 400;
  font-style: normal;
  background-color:#efefea;
  margin:0;
  color:#101820;
  transition:all 0.5s ease-in-out;
}


h1{
  font-size:36px;
  margin-top:0;
}

h1, h2, .h1, .h2 {
  font-weight:500;
}



h2, .h2 {
  color:#ce0e2d;
  font-size:36px;
  margin-bottom:22px;
}


h3{
  font-weight:500;
  color:#8b6f4b;
  font-size:23px;
  line-height:24px;
}
a{
  text-decoration: none;
  background-repeat: no-repeat;
}

a:link{
  color:#000;
}

a:visited{
  color:#000;
}

a:hover{
  color:#ce0e2d;
}

div{
  background-repeat: no-repeat;
}

a.bigbutton{
  display:inline-block;
  border-radius:5px;
  background-color:#a7aba1;
  color:#fff;
  font-size:17px;
  line-height:20px;
  padding:5px 15px;
  margin-right:3px;
  cursor:pointer;
  transition:all 0.15s ease;
  position:relative;
  user-select: none;
}

a.button{
  background-color:#a7aba1;
  border-radius:5px;
  padding:5px 15px;
  display:inline-block;
  font-size:14px;
  line-height:14px;
  color:#fff;
  margin-right:5px;
}

a.button.router-link-active{
  background-color:#ce0e2d;
}

a.button:hover, a.button.green:hover{
  background-color:#ce0e2d;
}

a.button.green{
  background-color:#98b8ad;
}

a.bigbutton.green{
  background-color:#98b8ad;
}

a.bigbutton:hover{
  background-color:#ce0e2d;
}

a.bigbutton:active{
  background-color:#000;
}

strong{
  font-weight:500;
}

.site-holder{
  max-width:1750px;
  margin-left:auto;
  margin-right:auto;
  position:relative;
  box-sizing:border-box;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}


#nav a.router-link-exact-active {
  color: #ce0e2d;
}

.mr4{
  margin-right:4px;
}

.about{
  padding:40px;
}

.multiply{
  mix-blend-mode: multiply;
}

.fg-greytext{
  color:#b5b3a9;
}

.pre-break{
  white-space:pre-line;
}

.fullwidth{
  padding:45px;
  background-color:#f9f9f9;
  position:relative;
  box-sizing:border-box;
}

.fullwidth.shallow{
  padding-top:10px;
  padding-bottom:10px;
  margin-bottom:8px;
}

.fullwidth.spaceover{
  margin-top:10px;
  padding-bottom:10px;
}

.darker{
  background-color:#efefea;
}

.a-right{
  text-align:right;
}

a.button-link{
  display:inline-block;
  border-radius:5px;
  background-color:#a7aba1;
  color:#fff;
  font-size:14px;
  line-height:14px;
  padding:5px 15px;
  margin-right:3px;
  cursor:pointer;
  transition:all 0.15s ease;
  position:relative;
  user-select: none;
}

a.button-link.router-link-exact-active{
  background-color:#ce0e2d;
}

a.button-link:first-child{
  margin-left:0;
}

a.button-link:last-child{
  margin-right:0;
}

a.button-link.large{
  font-size:17px;
  line-height:20px;
  margin-left:5px;
}

a.button-link.large:first-child
{
  margin-left:0;
}

a.button-link:hover{
  background-color:#ce0e2d;
}

a.button-link:active{
  background-color:#000;
}


.close-box{
  position:absolute;
  top:45px;
  right:45px;
  width:32px;
  height:32px;
  background-repeat:none;
  background-size: contain;
  background-image: url('./assets/img/close.svg');
  z-index:10;
  cursor:pointer;
  transition:all 0.1s linear;
}

.close-box.grey{
  opacity:0.5;
}

.close-box.white{
  background-image: url('./assets/img/close-white.svg');
}

.close-box.small{
  width:24px;
  height:24px;
  top:24px;
  right:24px;
}

.close-box.small.tight{
  top:16px;
  right:16px;
}

.close-box:hover{
  background-image: url('./assets/img/close-red.svg');
  transform: scale(1.1);
  opacity:1;
}

.close-box:active{
  transform: scale(1.2);
}

.lightbox{
  width:100vw;
  height:100vh;
  position:fixed;
  top:0;
  left:0;
  background-color:#00000088;
  cursor:pointer;
  z-index:5000;
}

.ql-container{
  font-family: gibbs, sans-serif;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.faderight-enter-active, .faderight-leave-active {
  transition: opacity .3s ease;
}
.faderight-enter, .faderight-leave-to {
  opacity: 0;
  transform: translateX(200px);
}

.fscale-enter-active, .fscale-leave-active {
  transition: all .2s ease-in;
}

.fscale-enter, .fscale-leave-to {
  transform: scale(0.6);
  opacity: 0;
}

.fadeslow-enter-active, .fadeslow-leave-active {
  transition: opacity .6s;
}
.fadeslow-enter, .fadeslow-leave-to {
  opacity: 0;
}

input:focus,
select:focus,
textarea:focus,
button:focus {
    outline: none;
}

.tag.region {
  background-color:#8b6f4b;
  font-size:14px;
}

.tag.region:hover{
  background-color:#ce0e2d;
}

.flex-start{
  display:flex;
  align-items:flex-start;
  justify-content: space-between;
}

.likebox-holder{
  position:absolute;
  right: 13px;
  top:16px;
}
.bold{
  font-weight:500;
}

.greybar{
  padding:13px 13px 13px 13px;
  background-color:#efefea;
  font-weight:500;
  font-size:20px;
  display:flex;
  justify-content: space-between;
  position:absolute;
  bottom:0;
  left:0;
  width:100%;
  box-sizing:border-box;
  z-index:40;
}

.narex{
  padding-left:65px;
  padding-right:65px;
}

.font-med{
  font-weight:500;
}
.font-book{
  font-weight:400;
}
.font-light{
  font-weight:300;
}

.zoom-lightbox{
  z-index:500;
  position:fixed;
  top:0;
  left:0;
  bottom:0;
  right:0;
  background-color:#00000088;
  cursor:pointer;
}

.centralizer{
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
  z-index:505;
}

.input-panel .item{
  display:flex;
  align-items:flex-start;
  margin: 6px 0;
}

.input-panel .item input[type="text"], .input-panel .item textarea, .input-panel .item input[type="email"], .input-panel .item select{
  width:100%;
  border-radius:5px;
  border:1px solid #a7aba1;
  padding:6px;
  box-sizing:border-box;
}

label{
  color:#6d6d64;
}

.input-panel .item label{
  display:block;
  margin-right:10px;
  margin-top:4px;
  width:25%;
}

textarea{
  font-family: gibbs, sans-serif;
}

.centered{
  text-align:center;
}

/* popup message box */
.message-panel{
  width:70vw;
  max-width: 500px;
  background-color:#fff;
  z-index:5100;
  padding:25px;
  cursor:default;
  max-height:98vh;
  overflow-y:auto;
  box-sizing: border-box;
}

.message-panel .title{
  font-size:30px;
  font-weight:500;
  margin:20px;
}

.message-panel .message{
  margin:20px;
}

.edit-button{
  position:absolute;
  top:0;
  right:0;
  width:20px;
  height:20px;
  background-repeat: no-repeat;
  background-image: url('./assets/img/edit.svg');
  background-size: contain;
  background-position:center center;
  cursor: pointer;
  opacity:0.1;
}

.edit-button:hover{
  opacity:1.0;
}

.ql-size-small{
  font-size:14px;
}

.search-item{
  padding-left:16px;
}

.search-item.sel{
  background-image:url('./assets/img/circle.svg');
  background-repeat:no-repeat;
  background-size:auto 40%;
  background-position:center left;
}

.search-item.sel a{
  color:#ce0e2d;
}

.search-item:hover{
  color:#ce0e2d;
}

.flex-images, .flex-anim-images{
  display:flex;
  position:relative;
  justify-content: space-between;
  padding-bottom:1%;
  flex-wrap: wrap;
  width:100%;
  overflow:hidden;
}

.flex-images .imdiv{
  position:relative;
  width:19%;
  padding-bottom:50px;
  margin-bottom:1%;
  cursor:pointer;
  background-color:#efefea;
}

.flex-images .imdiv:empty
{
  background-color:transparent;
}

.flex-images img.main, .flex-anim-images img.main{
  width: 100%;
  display:block;
}


.flex-anim-images .imdiv{
  position:relative;
  width:24%;
  padding-bottom:0;
  margin-bottom:1.35%;
  cursor:pointer;
}



.no-top-padding{
  padding-top:0;
}

.small-bottom-padding{
  padding-bottom:20px;
}

.small-top-padding{
  padding-top:20px;
}

.imdiv .artist-name{
  box-sizing:border-box;
  padding-right:30px;
}

.imdiv:hover .artist-name{
  color:#ce0e2d;
}

.imdiv .artist-name a{
  color:#000;
}

.imdiv:hover .artist-name a{
  color:#ce0e2d;
}


.x-quill-ps a{
  color:#ce0e2d;
}

.x-quill-ps a:hover{
  color:#ce0e2d;
  text-decoration:underline;
}

.imdiv:hover .tag-panel{
  display:block;
}



.tag{
  border-radius:5px;
  padding:4px 6px;
  background-color:#98b8ad;
  color:#fff;
  display:inline-block;
  font-size:15px;
  font-weight:400;
  margin-bottom:4px;
  margin-right:4px;
  box-sizing:border-box;
  line-height:15px;
  cursor:pointer;
  user-select: none;
  transition:all 0.1s linear;
  text-decoration: none;
}

a.redlink{
  color:#ce0e2d;
  font-weight:500;
}

a.redlink:hover{
  color:#000;
}

a.tag{
  color:#fff;
}

.tag:hover{
  background-color:#ce0e2d;
}
.tag:active{
  background-color:#000;
  box-shadow:1px 1px 3px rgba(0,0,0,0.5);
}

.square-filler{
  width:100%;
  padding-bottom:100%;
  z-index:0;
  overflow:hidden;
}



.video-loader-icon{
    position:absolute;
    top:35%;
    left:35%;
    width:30%;
    height:30%;
    user-select: none;
    pointer-events: none;
    background-image:url('./assets/img/spinner.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: auto 50%;
    animation: vidrotateme 3s infinite linear;
  }

  .video-loader-icon.cued, .cued .video-loader-icon{
    display:none;
  }

  .style-browser{
  
  margin-left:5vw;
  margin-right:5vw;
  
}
.style-browser a{
  display:block;
  text-decoration:none;
  color:#6d6d64;
}

.style-browser a:hover{
  color:#ce0e2d;
}

.style-browser .h2{
  font-size:34px;
  line-height:32px;
  font-weight:500;
  color:#000;
}

.style-browser .h2.lt{
  font-weight:400;
  font-size:30px;
}

.style-browser .browse-col{
  margin: 10px auto 30px auto;
  line-height:30px;
  font-size:18px;
  font-weight:300;
  text-align:center;
}

.style-browser .two-col{
  column-count:2;
  column-gap: 32px;
}

.style-browser .browse-col .h2{
  white-space: nowrap;
  margin-bottom:40px;
}

.full-video{
  width:100%;
  display:block;
}

.noBottom .style-button-group{
  margin-bottom:0;
}

.lc{
  text-transform:lowercase;
}

.preload{
  display:none;
}






@keyframes vidrotateme {
  0% {
    transform: rotate(0); 
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width:1750px){
  .site-holder{
    margin:0;
    max-width:100vw;
  }
}


@media screen and (max-width:1300px){
  .flex-images .imdiv{
    position:relative;
    width:24%;
    padding-bottom:3%;
    margin-bottom:1%;
    
  }

  .flex-anim-images .imdiv{
    width:32.5%;
  }

  .style-browser{
    margin-left:0;
    margin-right:0;
  }
}

@media screen and (max-width:480px) and ( min-width: 400px){
  .greybar{
    font-size:18px;
  }
  
}

@media screen and (max-width:1100px){
  .narex{
    padding-left:25px;
    padding-right:25px;
  }
  .fullwidth{
    padding-left:25px;
    padding-right:25px;
  }
  
}

@media screen and (max-width:1023px){
  .style-browser .browse-col .h2{
    margin-top:0;
  }
  #category-col, #medium-col{
    display:none;
  }
}

@media screen and (max-width:768px){
  .flex-anim-images .imdiv{
    width:49.3%;
  }

  .style-browser{
    display:block;
  }

  .style-browser .browse-col{
    margin:10px;
  }

  .style-browser .browse-col .h2{
    white-space:normal;
  }

  

}
@media screen and (max-width:960px){
  .flex-images .imdiv{
    position:relative;
    width:32.5%;
    padding-bottom:3%;
    margin-bottom:1%;
    
  }
  .close-box{
    top:20px;
    right:20px;
  }

  .close-box.small{
    top:16px;
    right:16px;
  }
}

@media screen and (max-width:640px){

  h1{
    font-size:24px;
  }

  .flex-images .imdiv{
    width:49.5%;
    margin-bottom:10px;
  }

  .fullwidth{
    padding-top:20px;
    padding-left:10px;
    padding-right:10px;
  }

  

  .hide-tiny{
    display:none;
  }

  .close-box{
    top:10px;
    right:10px;
  }
}

@media screen and (max-width:400px){
  .flex-images .imdiv{
    width:100%;
    margin-bottom:10px;
  }
}


</style>
